import React from "react";
import { BaseSkeleton } from "components/Skeleton";

import {
    SkeletonCard,
    SkeletonCardContent,
    SkeletonCards,
    SkeletonHero,
    SkeletonHeroBackground,
    SkeletonHeroContent,
    SkeletonRoot,
    SkeletonSection,
    SkeletonSections,
} from "./styled";

export default function DashboardHomeSkeleton() {
    return (
        <SkeletonRoot>
            <SkeletonHero>
                <SkeletonHeroContent>
                    <BaseSkeleton height={14} width={116} borderRadius={999} />
                    <BaseSkeleton height={72} width="min(840px, 74vw)" borderRadius={18} />
                    <BaseSkeleton height={18} width="min(640px, 54vw)" />
                    <BaseSkeleton height={18} width="min(580px, 48vw)" />
                    <BaseSkeleton height={56} width={188} borderRadius={12} />
                </SkeletonHeroContent>
            </SkeletonHero>

            <SkeletonSections>
                {Array.from({ length: 3 }).map((_, sectionIndex) => (
                    <SkeletonSection key={sectionIndex}>
                        <BaseSkeleton height={32} width={sectionIndex === 0 ? 240 : 200} />

                        <SkeletonCards>
                            {Array.from({ length: sectionIndex === 0 ? 3 : 4 }).map((__, cardIndex) => (
                                <SkeletonCard key={`${sectionIndex}-${cardIndex}`}>
                                    <BaseSkeleton height="100%" borderRadius="16px" />

                                    <SkeletonCardContent>
                                        <BaseSkeleton height={18} width={sectionIndex === 2 ? "54%" : "68%"} />
                                        <BaseSkeleton height={16} width="38%" />
                                    </SkeletonCardContent>
                                </SkeletonCard>
                            ))}
                        </SkeletonCards>
                    </SkeletonSection>
                ))}
            </SkeletonSections>
        </SkeletonRoot>
    );
}
